import React from 'react';
import StatusIconMedium from '../Icons/StatusSmall';

type Props = {
  record?: any,
  source: string
};

const StatusField = (props: Props) => (
  <StatusIconMedium enabled={props.record[props.source]} />
);

export default StatusField;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/StatusField.tsx